import {closeSearch} from "./SearchBar";
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const bodyEl = document.querySelector('body');
const headerEl = document.querySelector('.main-header');
const menuEl = document.querySelector('.main-header__mobile-items-wrapper');
const menuTrigger = document.querySelector('.main-header__menu-icon');
const subMenusTriggerAll = menuEl?.querySelectorAll('.menu-item-has-children > a');
const subMenuBackAll = menuEl?.querySelectorAll('.menu-item-parent-label');

const locale = {
    bodyClass: 'main-menu-active',
    activeClass: 'active',
    stickyBackground: 'main-header--white'
};

const CLOSE = 0;
const OPEN = 1;
let state = CLOSE;

/**
 * Toggle background header depends on scroll page. Also can be force by forceEnable on true.
 * @param forceEnable
 */
export const changeBackground = (forceEnable = false) => {
    (forceEnable || window.scrollY > 0)
        ? headerEl.classList.add(locale.stickyBackground)
        : headerEl.classList.remove(locale.stickyBackground);
}

/**
 * Close all sub-menu navigations to avoid wrong depth level on open again main navigation.
 */
const closeAllSubmenu = () => {
    subMenusTriggerAll.forEach(subMenusTriggerEl => {
        subMenusTriggerEl.nextElementSibling.classList.remove(locale.activeClass);
    });
}

/**
 * Close current open sub-menu. Triggered by element prepared in nav structure (.menu-item-parent-label).
 * @param currentTarget - Node element for clicked trigger element.
 */
const closeSubmenu = ({currentTarget}) => {
    event.preventDefault();
    const submenu = currentTarget.parentElement

    submenu.classList.remove(locale.activeClass);
    enablePageScroll(submenu);
}

/**
 * Open sub-menu for default WP nav structure.
 * @param currentTarget - Node element for clicked trigger element.
 */
const openSubmenu = ({currentTarget}) => {
    event.preventDefault();

    const submenu = currentTarget.nextElementSibling

    submenu.classList.add(locale.activeClass);
    disablePageScroll(submenu);
}

/**
 * Close main navigation wrapper.
 */
export const closeMenu = () => {
    enablePageScroll();

    state = CLOSE;
    bodyEl.classList.remove(locale.bodyClass);
    menuEl.classList.remove(locale.activeClass);
    menuTrigger.classList.remove(locale.activeClass);
    closeAllSubmenu();
}

/**
 * Open main navigation wrapper.
 */
export const openMenu = () => {
    closeSearch()
    disablePageScroll();

    state = OPEN;
    bodyEl.classList.add(locale.bodyClass);
    menuEl.classList.add(locale.activeClass);
    menuTrigger.classList.add(locale.activeClass)
}

/**
 * Logic for toggle main nav wrapper.
 */
export const toggleMenu = () => {
    state === CLOSE ? openMenu() : closeMenu();
}

/**
 * Initial actions.
 * Add listeners for interactive menu.
 */
const init = () => {
    if ( menuTrigger && menuEl ) {
        menuTrigger.addEventListener('click', toggleMenu);

        subMenusTriggerAll.forEach(subMenuTriggerEl => {
            subMenuTriggerEl.addEventListener('click', openSubmenu)
        });

        subMenuBackAll.forEach(subMenuBackEl => {
            subMenuBackEl.addEventListener('click', closeSubmenu)
        });
    }
}

export default init;
